import { cva } from 'class-variance-authority';

export const pageButtonStyles = cva(
  [
    'flex',
    'items-center',
    'justify-center',
    'min-w-8',
    'min-h-8',
    'w-8',
    'h-8',
    'text-body-small',
    'max-md:leading-normal',
    'md:text-body-regular',
  ],
  {
    variants: {
      selected: {
        true: '!text-blue-300 border-b border-blue-300',
        false: 'text-grey-700 max-md:rounded-md',
      },
      disabled: {
        true: 'cursor-auto text-neutral-700',
        false: 'cursor-pointer text-blue-300',
      },
      dots: {
        true: 'cursor-auto',
        false: 'cursor-pointer',
      },
    },
    defaultVariants: {
      selected: false,
      disabled: false,
      dots: false,
    },
  }
);

export const iconContainerStyles = cva(['flex', 'items-center', 'justify-center', 'w-8', 'h-8', 'max-md:rounded-md'], {
  variants: {
    disabled: {
      true: ['cursor-auto', '[&>svg]:text-neutral-400 border-grey-300 text-neutral-700 fill-current'],
      false: ['cursor-pointer', '[&>svg]:text-black text-black fill-current border-blue-150'],
    },
  },
  defaultVariants: {
    disabled: false,
  },
});
